import { Box, Button, Grid, Typography, TextField } from "@material-ui/core";
import { Localizations } from "../../../Shared/sharedTypes";
import React, { useState } from "react";
import { Order } from "../../../Shared/GeneratedTypes";

interface propsType {
    provideFeedback: (feedback: string) => void;
    order: Order;
    localizations: Localizations;
}

export default function ProvideFeedback({ order, localizations, provideFeedback }: propsType) {
    const [feedback, setFeedback] = useState<string>(order.clientFeedback?.feedback || "");
    return (
        <>
            <Grid
                item
                className="transparentBackground"
                container
                style={{ flex: 1, backgroundColor: "#85C441AA", position: "relative" }}
            >
                <Box
                    p={2}
                    borderRadius={10}
                    textAlign="center"
                    style={{
                        backgroundColor: "white",
                        position: "absolute",
                        overflowY: "auto",
                        top: 24,
                        bottom: 24,
                        left: 24,
                        right: 24,
                    }}
                >
                    <Typography variant="h6">{localizations.howDidWeDo}</Typography>
                    <Box pt={2} pb={2}>
                        <TextField
                            id="feedback"
                            label={localizations.yourMessage}
                            multiline
                            fullWidth
                            rows={4}
                            value={feedback}
                            onChange={(e) => setFeedback(e.currentTarget.value)}
                            placeholder={localizations.pleaseProvideAQuickMessage}
                        />
                    </Box>
                    <Box pt={2} pb={2}>
                        <Button onClick={() => provideFeedback(feedback)}>{localizations.submitFeedback}</Button>
                    </Box>
                </Box>
            </Grid>
        </>
    );
}
